import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faUsers, faShieldAlt, faGlobe } from '@fortawesome/free-solid-svg-icons';
import '../styles/about.css';

const About = () => {
    const [statistics, setStatistics] = useState({
        total_users: null,
        total_products: null,
        active_products: null
    });

    useEffect(() => {
        // Fetch real statistics from API
        const fetchStatistics = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/statistics/`);
                if (response.ok) {
                    const data = await response.json();
                    setStatistics(data);
                }
            } catch (error) {
                console.error('Error fetching statistics:', error);
                // Keep showing loading state if API fails
            }
        };

        fetchStatistics();
    }, []);

    // Format large numbers with K for thousands, M for millions
    const formatNumber = (num) => {
        if (num === null) return '...';
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    };

    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className="about-container">
            <motion.section className="hero-section" {...fadeIn}>
                <h1>À propos de Wennze</h1>
                <p className="subtitle">Connecter les gens, Créer des opportunités</p>
            </motion.section>

            <motion.section className="mission-section" {...fadeIn} transition={{ delay: 0.2 }}>
                <h2 class="h2">Notre Mission</h2>
                <p>
                    Wennze est née d'une vision simple mais puissante : créer une plateforme qui
                    facilite les échanges commerciaux en République Démocratique du Congo tout en
                    favorisant une économie collaborative et durable.
                </p>
            </motion.section>

            <motion.section className="values-section" {...fadeIn} transition={{ delay: 0.4 }}>
                <h2>Nos Valeurs</h2>
                <div className="values-grid">
                    <div className="value-card">
                        <FontAwesomeIcon icon={faHandshake} className="value-icon" />
                        <h3 className='h3'>Confiance</h3>
                        <p>Nous construisons des relations durables basées sur la transparence et l'intégrité.</p>
                    </div>
                    <div className="value-card">
                        <FontAwesomeIcon icon={faUsers} className="value-icon" />
                        <h3 className='h3'>Communauté</h3>
                        <p>Nous créons des connexions significatives qui enrichissent notre communauté.</p>
                    </div>
                    <div className="value-card">
                        <FontAwesomeIcon icon={faShieldAlt} className="value-icon" />
                        <h3 className='h3'>Sécurité</h3>
                        <p>Nous protégeons nos utilisateurs avec des systèmes de sécurité avancés.</p>
                    </div>
                    <div className="value-card">
                        <FontAwesomeIcon icon={faGlobe} className="value-icon" />
                        <h3 className='h3'>Innovation</h3>
                        <p>Nous innovons constamment pour améliorer l'expérience de nos utilisateurs.</p>
                    </div>
                </div>
            </motion.section>

            <motion.section className="vision-section" {...fadeIn} transition={{ delay: 0.6 }}>
                <h2>Notre Vision</h2>
                <div className="vision-content">
                    <p>
                        Nous aspirons à devenir la première plateforme de commerce en ligne en RDC,
                        en offrant une expérience utilisateur exceptionnelle et en contribuant au
                        développement économique local.
                    </p>
                </div>
            </motion.section>

            <motion.section className="stats-section" {...fadeIn} transition={{ delay: 0.8 }}>
                <div className="stats-grid">
                    <div className="stat-card">
                        <h3 className='h3'>
                            {formatNumber(statistics.total_users)}{statistics.total_users !== null && '+'}
                        </h3>
                        <p>Utilisateurs Actifs</p>
                    </div>
                    <div className="stat-card">
                        <h3 className='h3'>
                            {formatNumber(statistics.total_products)}{statistics.total_products !== null && '+'}
                        </h3>
                        <p>Produits Publiés</p>
                    </div>
                    <div className="stat-card">
                        <h3 className='h3'>26</h3>
                        <p>Provinces Couvertes</p>
                    </div>
                    <div className="stat-card">
                        <h3 className='h3'>24/7</h3>
                        <p>Support Client</p>
                    </div>
                </div>
            </motion.section>
        </div>
    );
};

export default About;